<template>
  <div class="invoice-history-detail">
    <fixed-header title="发票详情"></fixed-header>
    <div class="invoice-history-detail__main scroll-touch">
      <div class="invoice-history-detail__status invoice-history-detail__warp">
        <span>发票总数</span>
        <span
            :class="['invoice-history-detail__status-desc', (getInvoiceStatus(invoiceInfo.review, invoiceInfo.status) != 0) ? 'active':'', invoiceInfo.status === 1 ? '':'distance']"
            @click="showInvoiceImg(invoiceInfo.review, invoiceInfo.status)">{{
            endowValue(this.invoiceStatus, getInvoiceStatus(invoiceInfo.review, invoiceInfo.status))
          }}</span>
        <i v-if="invoiceInfo.status === 1 && invoiceInfo.review === 1"
           :class="['icon', 'invoice_arrow_trans', 'trans']"></i>
      </div>
      <div v-if="invoiceInfo.titleType === 0" class="invoice-history-detail__info invoice-history-detail__warp">
        <div class="invoice-history-detail__info-item">
          <span>公司名称</span>
          <span class="invoice-history-detail__info-item-option">{{ invoiceInfo.invoiceTitle }}</span>
        </div>
        <div class="invoice-history-detail__info-item">
          <span>公司税号</span>
          <span class="invoice-history-detail__info-item-option">{{ invoiceInfo.taxpayer }}</span>
        </div>
        <div class="invoice-history-detail__info-item">
          <span>注册地址</span>
          <span class="invoice-history-detail__info-item-option">{{ invoiceInfo.address }}</span>
        </div>
        <div class="invoice-history-detail__info-item">
          <span>注册电话</span>
          <span class="invoice-history-detail__info-item-option">{{ invoiceInfo.phone }}</span>
        </div>
        <div class="invoice-history-detail__info-item">
          <span>开户银行</span>
          <span class="invoice-history-detail__info-item-option">{{ invoiceInfo.bankName }}</span>
        </div>
        <div class="invoice-history-detail__info-item">
          <span>银行账号</span>
          <span class="invoice-history-detail__info-item-option">{{ invoiceInfo.bankAccount }}</span>
        </div>
      </div>
      <div v-if="invoiceInfo.titleType === 1" class="invoice-history-detail__info invoice-history-detail__warp">
        <div class="invoice-history-detail__info-item">
          <span>抬头名称</span>
          <span class="invoice-history-detail__info-item-option">{{ invoiceInfo.invoiceTitle }}</span>
        </div>
      </div>
      <div class="invoice-history-detail__order invoice-history-detail__warp">
        <span>1张发票，共{{ invoiceInfo.orderNum }}个订单</span>
        <span class="invoice-history-detail__order-desc"
              @click="gotoInvoiceOrder(invoiceInfo.invoiceApplySn)">订单查看</span>
        <i :class="['icon', 'invoice_arrow_trans', 'trans']"></i>
      </div>
      <div class="invoice-history-detail__receive invoice-history-detail__warp">
        <div class="invoice-history-detail__receive-item">
          <span>接收方式</span>
        </div>
        <div class="invoice-history-detail__receive-item">
          <span class="invoice-history-detail__receive-item-email">电子邮箱</span>
          <span class="invoice-history-detail__receive-item-option">{{ invoiceInfo.noticeEmail }}</span>
        </div>
      </div>
      <div v-if="invoiceInfo.review === 2" class="invoice-history-detail__check invoice-history-detail__warp">
        <div class="invoice-history-detail__check-item">
          <span class="invoice-history-detail__check-item-title">审核意见</span>
        </div>
        <div class="invoice-history-detail__check-item">
          <span class="invoice-history-detail__check-item-msg">{{ invoiceInfo.remark }}</span>
        </div>
      </div>
      <div
          v-if="getInvoiceStatus(invoiceInfo.review, invoiceInfo.status) !== 0 && getInvoiceStatus(invoiceInfo.review, invoiceInfo.status) !== 1"
          class="invoice-history-detail__button">
        <div v-if="invoiceInfo.review === 2" class="invoice-history-detail__button-item" @click="gotoInvoiceAgainOrder">
          <span>重新申请</span>
        </div>
        <div v-if="invoiceInfo.review === 1 && invoiceInfo.status === 1"
             class="invoice-history-detail__button-item"
             @click="gotoInvoiceAgain(invoiceInfo.invoiceApplySn)">
          <span>重新发票</span>
        </div>
      </div>
    </div>
    <goods-preview :defaultIndex="defaultImgIndx" :images="invoiceImg" :isShow="isShowBigImage"
                   @close="isShowBigImage=false"></goods-preview>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import GoodsPreview from 'components/common/GoodsPreview';
import * as invoiceApis from 'apis/invoice';

export default {
  name: 'index',
  components: {
    FixedHeader, GoodsPreview,
  },
  data() {
    const {
      id: invoiceId,
    } = this.$route.query;
    const nowId = invoiceId ? Number(invoiceId) : 0;
    return {
      nowId,
      defaultImgIndx: 0,
      isShowBigImage: false,
      invoiceImg: [],
      invoiceInfo: {},
      reviewType: [
        { value: 0, label: '待审核' },
        { value: 1, label: '审核通过' },
        { value: 2, label: '审核不通过' },
      ],
      statusType: [
        { value: 0, label: '待开' },
        { value: 1, label: '已开' },
        { value: 2, label: '已作废' },
      ],
      invoiceStatus: [
        { value: 0, label: '待审核' },
        { value: 1, label: '审核通过/待开' },
        { value: 2, label: '已开票' },
        { value: 3, label: '审核不通过' },
      ],
    };
  },
  mounted() {
    this.getInvoiceInfo();
  },
  methods: {
    getInvoiceStatus(scope1, scope2) {
      if (scope1 === 0) {
        return 0;
      } else if (scope1 === 1) {
        if (scope2 === 0) {
          return 1;
        } else if (scope2 === 1) {
          return 2;
        }
        return 4;
      }
      return 3;
    },
    endowValue(arr, scope) {
      if (arr && arr.length) {
        const e = arr.find(v => v.value === scope);
        if (e) {
          return e.label;
        }
        return '';
      }
      return '';
    },
    showInvoiceImg(review, status) {
      if (review === 1 && status === 1) {
        MgStat.send('click', { review: this.invoiceInfo.review, status: this.invoiceInfo.status }, {
          mod: 'invoice',
          cont: '点击已开票',
          direct: 'cntp',
          label: 'btn',
          cntp: 'haowu_invoiceHistoryDetail',
        });
        this.isShowBigImage = true;
      }
    },
    gotoInvoiceOrder(invoiceApplySn) {
      MgStat.send('click', { review: this.invoiceInfo.review, status: this.invoiceInfo.status }, {
        mod: 'order_query',
        cont: '点击订单查看',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceHistoryDetail',
      });
      this.$router.push({ path: '/invoice/history/order', query: { invoiceApplySn } });
    },
    gotoInvoiceAgain(invoiceApplySn) {
      MgStat.send('click', { review: this.invoiceInfo.review, status: this.invoiceInfo.status }, {
        mod: 'reset_invoice',
        cont: '点击重发发票',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceHistoryDetail',
      });
      this.$router.push({ path: '/invoice/history/again', query: { invoiceApplySn } });
    },
    gotoInvoiceAgainOrder() {
      MgStat.send('click', { review: this.invoiceInfo.review, status: this.invoiceInfo.status }, {
        mod: 'invoice_order',
        cont: '点击重新申请',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceHistoryDetail',
      });
      this.$router.push({ path: '/invoice/order' });
    },
    async getInvoiceInfo() {
      try {
        const data = await invoiceApis.getInvoiceInfo(this.nowId);
        if (data) {
          this.invoiceInfo = data;
          if (this.invoiceInfo.jpgUrl) {
            this.invoiceImg = this.invoiceInfo.jpgUrl.split(',');
          } else {
            console.log('#####图片为空');
          }
        }
      } catch (error) {
        const { message } = error;
        this.$toast(`获取开票记录失败:${message}`);
      }
    },
  },
};
</script>

<style lang="scss">

.trans {
  margin-right: 24px;
}

.invoice-history-detail {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
  }

  &__warp {
    margin-top: 20px;
    width: 100%;
    background: rgba(255, 255, 255, 1);
  }

  &__status {
    height: 90px;
    display: flex;
    align-items: center;

    span {
      display: block;
      font-size: 28px;
      margin-left: 24px;
      color: #323232;
    }

    &-desc {
      flex: 1;
      text-align: right;
      color: #BABABA !important; //加!important为强制使用当前样式
    }

    .active {
      color: #FF5F00 !important;
    }

    .distance {
      margin-right: 34px;
    }
  }

  &__info {
    margin-top: 20px;
    width: 100%;
    background: #ffffff;

    &-item {
      height: 90px;
      display: flex;
      align-items: center;

      span {
        display: block;
        font-size: 28px;
        margin-left: 24px;
        color: #BABABA;
      }

      &-option {
        margin-left: 40px !important;
        color: #323232 !important;
      }
    }
  }

  &__order {
    height: 90px;
    display: flex;
    align-items: center;

    span {
      display: block;
      font-size: 28px;
      margin-left: 24px;
      color: #323232;
    }

    &-desc {
      flex: 1;
      text-align: right;
      color: #BABABA !important; //加!important为强制使用当前样式
      font-size: 24px !important;
    }
  }

  &__receive {
    margin-top: 20px;
    width: 100%;
    background: #ffffff;

    &-item {
      height: 90px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      span {
        display: block;
        font-size: 28px;
        margin-left: 24px;
        color: #323232;
      }

      &-email {
        color: #BABABA !important;
      }

      &-option {
        margin-left: 40px !important;
      }
    }
  }

  &__check {
    margin-top: 20px;
    width: 100%;
    margin-bottom: 222px;
    background: #ffffff;

    &-item {
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      span {
        display: flex;
        align-items: center;
        font-size: 28px;
        margin-left: 24px;
        color: #323232;
      }

      &-title {
        height: 90px;
      }

      &-msg {
        margin: 23px 24px;
        color: #BABABA !important;
        min-height: 90px;
      }
    }
  }

  &__button {
    margin-top: 72px;
    padding-top: 3px;
    width: 100%;
    height: 150px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;

    &-item {
      margin-top: 20px;
      width: 702px;
      height: 80px;
      margin-left: 24px;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 28px;
        color: #FFFFFF;
      }
    }
  }


}
</style>
